import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { PayoutStatusDetailModal } from '@/types/modal';
import { usePayoutStatusDetail } from '@/hooks/item';
import { NoFooterModal } from '@/components/molecules/common/Modal';
import Table from '@/components/molecules/common/Table';
import { PayoutStatusDetail } from '@/types/item';
import { Box } from '@mui/material';

interface PayoutStatusDetailRow {
  itemId: number;
  amount: string;
  currency: string;
  id: number;
}

const PayoutStatusDetail: React.FC<{ modal: PayoutStatusDetailModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const response = usePayoutStatusDetail(modal.item.productSellerPayout.payoutId || 0);

  const columns: GridColDef[] = [
    { field: 'itemId', headerName: t('modal.payout_status_detail.item_id') },
    { field: 'amount', headerName: t('modal.payout_status_detail.amount') },
    { field: 'currency', headerName: t('modal.payout_status_detail.currency') },
  ];

  const rows: PayoutStatusDetailRow[] =
    response.kind === 'Loaded'
      ? // TODO: Fix this type assertion
        // eslint-disable-next-line
        (response.data as PayoutStatusDetail).data.map((item, index: number) => ({
          itemId: item.productId,
          amount: item.amount,
          currency: item.currency,
          id: index,
        }))
      : [];

  const body = (
    <Box sx={{ width: 500 }}>
      <Table
        rows={rows}
        columns={columns}
        loading={response.kind === 'Called'}
        table={{
          kind: 'Table',
        }}
      />
    </Box>
  );

  return (
    <NoFooterModal
      title={t('modal.payout_status_detail.title')}
      onClose={modal.onClose}
      body={body}
      modalName="payout_status_detail"
    />
  );
};

export default PayoutStatusDetail;
